module.exports = __webpack_public_path__ + "./fonts/montserrat-latin-800.35386154b78d046218fc8f88a44ff515.woff2";